import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [hamburgerClass, setHamburgerClass] = useState("hamburgerDiv");
  const [responsiveMenu, setResponsiveMenu] = useState(false);

  const burgerAnimation = () => {
    if (hamburgerClass === "hamburgerDiv") {
      setHamburgerClass("cross");
      setResponsiveMenu(true);
    } else {
      setHamburgerClass("hamburgerDiv");
      setResponsiveMenu(false);
    }
  };

  const profiles = [
    {
      img: "assets/icons/github-142-svgrepo-com.svg",
      link: "https://github.com/mohsinidrees2817",
    },
    {
      img: "assets/icons/gitlab-svgrepo-comm.svg",
      link: "https://gitlab.com/mohsinidrees2817",
    },
    {
      img: "assets/icons/linkedin-svgrepo-com.svg",
      link: "https://www.linkedin.com/in/mohsin-idrees-71160a233/",
    },
    {
      img: "assets/icons/twitter-svgrepo-com.svg",
      link: "https://twitter.com/Mohsin_FED",
    },
    {
      img: "assets/icons/behance-svgrepo-com.svg",
      link: "https://www.behance.net/Mohsin_Abbasi1",
    },
  ];

  return (
    <>
      <header className="flex w-full justify-between items-center px-2 sm:px-4 lg:px-16 py-10 max-w-[1480px] mx-auto relative">
        <div className="px-2">
          <img
            src="assets/mohsin-idrees-logo.png"
            alt="Mohsin Idrees Logo"
            className="max-w-[30px] md:max-w-[50px]"
          />
        </div>
        <div>
          <div
            className={`${hamburgerClass} z-[100]`}
            onClick={() => burgerAnimation()}
          >
            <svg id="icon" viewBox="0 0 400 600">
              <path
                d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
                className="paths"
                id="top"
              ></path>
              <path d="M300,320 L540,320" className="paths" id="middle"></path>
              <path
                d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
                className="paths"
                id="bottom"
                transform="translate(480, 320) scale(1, -1)         translate(-480, -318) "
              ></path>
            </svg>
          </div>
        </div>

        <nav
          className={`flex flex-col absolute top-24 right-0 shadow-lg shadow-gray-300 justify-center items-start gap-2 md:gap-8 bg-[#6601ff] max-w-[80px] md:max-w-[150px] w-full p-6  ${
            responsiveMenu ? "translate-x-[0px]" : "translate-x-60"
          } transition-all ease-in-out duration-500`}
        >
          {profiles.map((section, index) => (
            <Link
              to={section.link}
              target="_blank"
              key={`profile-${index}`}
              rel="noopener noreferrer"
            >
              <div className="border-2 p-2 lg:p-2 cursor-pointer rounded-full hover:bg-black/50 border-[#b988fb]">
                <img src={section.img} alt="" width={20} height={20} />
              </div>
            </Link>
          ))}
        </nav>
      </header>
    </>
  );
};

export default Header;
